import { useEffect } from 'react';

const KeyCodes = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ESC: 'Escape',
};

const getFocusableElements = (containerRef) =>
  containerRef.current.querySelectorAll('[data-selectable]');

const getCurrentFocusIndex = () =>
  document.activeElement?.attributes['data-selectable']?.value;

function useArrowNaviagtion({ onEscape, containerRef }) {
  const onKeyDown = ({ code }) => {
    if (code === KeyCodes.ARROW_UP) {
      const currentFocus = getCurrentFocusIndex();
      const focusableElements = getFocusableElements(containerRef);

      const nextIndex = Number(currentFocus) - 1;

      if (nextIndex >= 0) {
        const next = focusableElements[nextIndex];
        next?.focus();
      }
    }

    if (code === KeyCodes.ARROW_DOWN) {
      const currentFocus = getCurrentFocusIndex();
      const focusableElements = getFocusableElements(containerRef);

      const nextIndex = Number(currentFocus) + 1;

      if (nextIndex >= 0) {
        const next = focusableElements[nextIndex];
        next?.focus();
      }
    }

    if (code === KeyCodes.ESC) {
      const focusableElements = getFocusableElements(containerRef);
      const input = focusableElements[0];
      input.focus();
      onEscape();
    }
  };

  useEffect(() => {
    containerRef.current?.addEventListener('keydown', onKeyDown);
    return () =>
      containerRef.current?.removeEventListener('keydown', onKeyDown);
  }, [onKeyDown, containerRef]);
}

export default useArrowNaviagtion;
